import z from 'zod';

import { InspectionId, PropertyId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';

export const InspectionType = z.enum(['curbside', 'exteriorOnly', 'interiorAndExterior', 'other']);
export type InspectionType = z.infer<typeof InspectionType>;

export const InspectionOccupancyStatus = z.enum(['vacant', 'occupied', 'abandoned']);
export type InspectionOccupancyStatus = z.infer<typeof InspectionOccupancyStatus>;

export const InspectionOccupancyType = z.enum(['owner', 'tenant', 'unknown']);
export type InspectionOccupancyType = z.infer<typeof InspectionOccupancyType>;

export const InspectionGeneralCondition = z.enum([
  'c1', // Great condition, no work needed
  'c2', // Very minor work needed
  'c3', // Repairs needed to bring up to code
  'c4', // Structural issues, out of code, needs mechanicals
  'c5', // Significant damage, work required
  'c6', // Demolition candidate
  'inaccessible',
]);
export type InspectionGeneralCondition = z.infer<typeof InspectionGeneralCondition>;

export const InspectionInsurableDamages = z.enum(['fire', 'vandalism', 'wind', 'theft', 'water', 'notApplicable']);
export type InspectionInsurableDamages = z.infer<typeof InspectionInsurableDamages>;

export const Inspection = z.object({
  id: InspectionId,
  propertyId: PropertyId,
  date: zodJSPlainDate,
  repairEstimate: z.number().nonnegative().optional(),
  inspectionType: InspectionType,
  occupancyStatus: InspectionOccupancyStatus,
  occupancyType: InspectionOccupancyType,
  interiorAccessGranted: z.boolean(),
  generalCondition: InspectionGeneralCondition,
  insurableDamages: InspectionInsurableDamages,
  condemnedFlag: z.boolean().optional(),
  orderId: z.string().optional(), // Used to associate with an advance
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
});
export type Inspection = z.infer<typeof Inspection>;
